import { ArrowRight } from "lucide-react";
import { SHOPIFY_APP_STORE_URL } from "@/lib/appLinks";

export function CtaBand() {
  return (
    <section className="section">
      <div className="container-tight">
        <div className="relative overflow-hidden rounded-3xl bg-gradient-primary px-6 py-8 text-primary-foreground shadow-elevated md:px-12 md:py-10">
          <div className="absolute -right-16 -top-16 h-64 w-64 rounded-full bg-white/10 blur-3xl" aria-hidden />
          <div className="absolute -bottom-20 -left-10 h-72 w-72 rounded-full bg-white/10 blur-3xl" aria-hidden />
          <div className="relative flex flex-col items-start justify-between gap-5 md:flex-row md:items-center">
            <div>
              <h2 className="text-2xl font-bold md:text-3xl">Start splitting carts in under 5 minutes.</h2>
              <p className="mt-1 text-sm opacity-90 md:text-base">Free for development stores. No credit card required.</p>
            </div>
            <a
              href={SHOPIFY_APP_STORE_URL}
              target="_blank"
              rel="noreferrer"
              className="inline-flex shrink-0 items-center justify-center gap-2 rounded-lg bg-background px-5 py-3 text-sm font-semibold text-primary shadow-elevated transition-transform hover:scale-[1.02]"
            >
              Add to Shopify — Free Trial
              <ArrowRight className="h-4 w-4" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
